import React from "react";
import Select, { SelectProps, transformDataToSelectOption } from "@/components/atoms/Select";
import { useTranslation } from "react-i18next";
import { useGetCreateOrderValues } from "@/services/Orders";
import { CreateOrderDropdownValue } from "@/types";

type keyOptions = Extract<keyof CreateOrderDropdownValue, string>;

interface SelectPropsExtended extends SelectProps {
  valueKey: keyOptions;
  labelKey: keyOptions;
  editable?: boolean;
}

/**
 * SelectCondition component renders a Select dropdown for conditions.
 * - Uses translation for option labels.
 * @param {SelectPropsExtended} props - Props for the SelectCondition component.
 * @param {keyOptions} props.valueKey - Key to use for option values.
 * @param {keyOptions} props.labelKey - Key to use for option labels.
 */

const SelectCurrency: React.FC<SelectPropsExtended> = ({ valueKey, labelKey, ...restProps }: SelectPropsExtended) => {
  const { data, isLoading } = useGetCreateOrderValues();
  const { t } = useTranslation();

  const sourceData = data?.currencies || [];
  const options = transformDataToSelectOption(sourceData, valueKey || "id", labelKey || "value", t, undefined, true);

  return <Select data={options} loading={isLoading} {...restProps} />;
};
export default SelectCurrency;
